import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction } from "mobx";
import { routeLocationSubscriptionChangePlanPatch } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { localizePaymentInterval } from "../others/localizePaymentInterval.js";
import { formatNumber } from "../utils/getDecimalSeparator.js";
import { __ } from "../utils/i18n.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
class ChangePlan {
    get labelPrice() {
        const { labelPaymentInterval, data: { discount, productPlan: { price: [{ currency, recurringPrice }] } } } = this;
        const priceFormatted = formatNumber(recurringPrice);
        const defaultPrice = `${priceFormatted} ${currency} / ${labelPaymentInterval}`;
        return discount?.recurring && discount?.absoluteAmountRecurringPrice ? `<s>${defaultPrice}</s> ${formatNumber(discount.discountedRecurringPrice)} ${currency} <font color="#3f8600">(${__("you save %s", discount.relativeAmount % 5 === 0 ? `${discount.relativeAmount} %` : `${formatNumber(discount.absoluteAmountRecurringPrice)} ${currency}`)})</font>` : defaultPrice;
    }
    get labelImmediatePrice() {
        const { immediatePrice, discount, productPlan: { price: [{ currency }] } } = this.data;
        const immediatePriceFormatted = formatNumber(+immediatePrice);
        const defaultPrice = `${immediatePriceFormatted} ${currency}`;
        return discount ? `<s>${defaultPrice}</s> ${formatNumber(discount.discountedImmediatePrice)} ${currency} <font color="#3f8600">(${__("you save %s", discount.relativeAmount % 5 === 0 ? `${discount.relativeAmount} %` : `${formatNumber(discount.absoluteAmountImmediatePrice)} ${currency}`)})</font>` : defaultPrice;
    }
    get labelPaymentInterval() {
        return localizePaymentInterval(this.data.productPlan.paymentInterval);
    }
    constructor(data, store){
        this.apply = flow(function*() {
            const session = this.store.store;
            this.store.busy = true;
            yield session.probablyRenewJwt();
            try {
                yield realCommerceRequest({
                    location: routeLocationSubscriptionChangePlanPatch,
                    request: {
                        subscription: {
                            id: this.store.data.id
                        },
                        checkout: {
                            isTermsAccepted: true,
                            coupon: this.data.discount ? this.store.lastAppliedCoupon || undefined : undefined,
                            productPlan: {
                                id: this.data.productPlan.id
                            }
                        }
                    },
                    settings: {
                        headers: session.authorizationHeader
                    }
                });
                this.store.lastAppliedCoupon = "";
                // Reload all subscriptions
                session.fetchSubscriptions();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.store.busy = false;
            }
        });
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ChangePlan.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChangePlan.prototype, "labelPrice", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChangePlan.prototype, "labelImmediatePrice", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChangePlan.prototype, "labelPaymentInterval", null);
export { ChangePlan };
